<template>
    <section class="home-page-blog category-page-section">
        <div class="wrapper">
               <div class="col-lg-12 col-md-12 col-sm-12 mt-4">
        <div class="row">
          <div class="col-lg-6 col-md-6 col-sm-12">
            <div class="title-banner">
              <div class="title-content">
                <h1 :class="{ 'tamil-title-h2': selectedLanguage === 'ta', 'title-h2': selectedLanguage !== 'ta' }">Blogs</h1>
                <div class="address-section">
                  <img src="../assets/images/category-page-home-icon.svg" alt="home-icon" loading="lazy"/>
                  <p class="footer-add"><a href="/"> &nbsp;Home</a></p>
                   <img
                    src="../assets/images/next-page.svg"
                    alt="next-page"
                    class="next-page"
                    loading="lazy"
                  />
                  <p class="footer-add"><a href="">Blogs</a></p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-6 col-md-6 col-sm-12">
           <div class="right-ads-category">
              <Adsense
     data-ad-client="ca-pub-1763856178878021"
     data-ad-slot="2634101883">
</Adsense>
            </div>
          </div>
        </div>
      </div>
 <!-- <BellowHeader /> -->
            <div class="container mt-5">
               
                <h6>{{ translations.category }}</h6>
                 <select v-model="selectedCategory" @change="onCategoryChange" class="professional-select town">
            <option value="0">{{ translations.all }}</option>
            <option v-for="item in categoryData" :key="item.category_id" :value="item.category_id">{{ selectedLanguage ===
              'en' ? item.category : item.tn_category }}</option>
          </select>
            </div>
            <div class="row">
                <div v-if="isLoading" class="loader mt-4">
                    <div class="row">
                        <div v-for="index in 4" :key="index" class="col-lg-4 col-md-4 col-sm-12">
                            <div class="shimmer-card">
                                <p class="shimmer-line-img"></p>
                                <p class="shimmer-line"></p>
                                <p class="shimmer-line"></p>
                            </div>
                        </div>
                    </div>
                </div>

                <template v-else>
                    <div v-for="article in articles" :key="article.article_id" class="col-lg-4 col-md-4 col-sm-12 mb-4">
                        <div class="main-blog" @click="redirectToLink(article)">
                            <div class="blog-img">
                                <template v-if="article.images.length > 0">
                                    <img v-for="(image, imageIndex) in article.images.slice(0, 1)" :key="imageIndex"
                                        :src="image" loading="lazy" alt="Article Image" />
                                </template>
                                <template v-else>
                                    <img src="../assets/images/No-Data-list.webp" loading="lazy" alt="Blog Image" />
                                </template>
                            </div>
                            <div class="blog-content">
                                <p class="blog-category">{{ article.category }}</p>
                                <h2 class="blog-title">{{ article.title }}</h2>
                                <div class="blog-btn-sec">
                                    <div :class="{ 'blog-more-tamil': selectedLanguage === 'ta', 'blog-more': selectedLanguage !== 'ta' }" >
                                        <button :class="{ 'blog-more-btn-tamil': selectedLanguage === 'ta', 'blog-more-btn': selectedLanguage !== 'ta' }" @click="redirectToLink(article)">{{translations.readmore}}</button>
                                    </div>
                                    <div class="blog-date">
                                        <div class="date-icon">
                                            <img src="../assets/images/union-1.png" alt="union" loading="lazy">
                                        </div>
                                        <div class="date-blog">
                                            <span>&nbsp;&nbsp;{{ formatDate(article.created) }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </template>
            </div>
           <!-- <AboveFooter /> -->
        </div>
    </section>
</template>

<script>
import { en, ta } from "@/translations";
// import BellowHeader from './BellowHeader.vue';
// import AboveFooter from './AboveFooter.vue';
export default {
  props: ["selectedLanguage"],
  data() {
    return {
      articles: [],
      categoryData: null,
      selectedCategory: "0",
      currentPage: parseInt(localStorage.getItem("currentPage")) || 1,
      itemsPerPage: 10,
      totalItems: 0,
      isLoading: false
    };
  },
  computed: {
    translations() {
      return this.selectedLanguage === "en" ? en : ta;
    }
  },
    components: {
  //  BellowHeader,
  //  AboveFooter
  },
  mounted() {
    localStorage.removeItem("currentPage");
    this.fetchCategoryData();
    this.fetchFilteredData(this.selectedCategory, this.currentPage);
  },
  methods: {
    formatDate(date) {
      const formattedDate = new Date(date);
      const monthNames = [
        "JAN", "FEB", "MAR", "APR", "MAY", "JUN",
        "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"
      ];
      const day = String(formattedDate.getDate()).padStart(2, "0");
      const month = monthNames[formattedDate.getMonth()];
      const year = formattedDate.getFullYear();
      return `${month} ${day}, ${year}`;
    },
    fetchCategoryData() {
      fetch("https://vaiyal-app.herokuapp.com/getarticlecategory")
        .then(response => response.json())
        .then(data => {
          if (data.status === "success") {
            this.categoryData = data.data;
          } else {
            console.error("Error fetching category data:", data.msg);
            this.categoryData = [];
          }
        })
        .catch(error => {
          console.error("Error fetching category data:", error);
          this.categoryData = [];
        });
    },
    fetchFilteredData(categoryid, page) {
      this.isLoading = true;
      const payload = {
        categoryid: categoryid
      };
      const apiUrl = `https://vaiyal-app.herokuapp.com/filterarticle?page=${page}`;
      fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(payload)
      })
        .then(response => response.json())
        .then(data => {
          if (data.status === "success") {
            this.articles = data.data;
            this.totalItems = data.pages * this.itemsPerPage;
          } else {
            console.error("Error fetching filtered data:", data.msg);
            this.articles = [];
            this.totalItems = 0;
          }
        })
        .catch(error => {
          console.error("Error fetching filtered data:", error);
          this.articles = [];
          this.totalItems = 0;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    redirectToLink(article) {
      window.open(article.link, "_blank");
    },
    onPageChange(page) {
      if (page > 0 && page <= Math.ceil(this.totalItems / this.itemsPerPage)) {
        this.currentPage = page;
        localStorage.setItem("currentPage", page);
        this.fetchFilteredData(this.selectedCategory, page);
      }
    },
    onCategoryChange() {
      this.currentPage = 1;
      this.fetchFilteredData(this.selectedCategory, this.currentPage);
    }
  }
};
</script>

<style>
@import url("/src/components/BlogComponent.scss");
</style>